import { TRANSCRIPT_ONLY_MESSAGE_TYPES } from '@shared/types';
import { ChatMessage as ChatMessageInterface } from '@talon/web/lib/api';
import { Box } from 'grommet';
import { useEffect, useRef } from 'react';
import { ChatMessage } from './ChatMessage';
import { PendingBotMessage } from './PendingBotMessage';
import { InboxMessage } from './SupportChat';
export interface IMessageListProps {
  messages: Array<Partial<ChatMessageInterface> | InboxMessage>;
  variant?: 'inbox';
  pending?: boolean;
  onRetry?: (localId: string) => void;
}

/** Transcript-only rows (bot-multiturn-memory / FR-5.3, fix-bot-pipeline-hardening):
 * intermediate tool-call rounds and tool results are persisted for multi-turn bot memory
 * but never render as chat bubbles. Derived from the shared
 * TRANSCRIPT_ONLY_MESSAGE_TYPES so the web render filter and the API's unread-count
 * whitelist come from one source and cannot drift. */
const transcriptOnly = new Set(TRANSCRIPT_ONLY_MESSAGE_TYPES as string[]);
const isRenderable = (message: Partial<ChatMessageInterface>): boolean => !transcriptOnly.has(message.type as string);

export const MessageList = ({ messages, variant, pending, onRetry }: IMessageListProps) => {
  const messageListRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current?.scrollTo(0, messageListRef.current.scrollHeight);
    }
  }, [messages, pending]);

  return (
    <Box
      background={variant === 'inbox' ? '#F7F7F7' : 'white'}
      border={variant === 'inbox' ? undefined : { color: '#d9d9e3' }}
      justify="start"
      alignContent="start"
      direction="column"
      flex
      overflow={{ vertical: 'auto' }}
      ref={messageListRef}
    >
      {messages.filter(isRenderable).map((message, index) => (
        <ChatMessage
          message={message}
          index={index}
          key={('localId' in message && message.localId) || message.id || `chatMessage-${index}`}
          variant={variant}
          onRetry={onRetry}
        />
      ))}
      {pending && <PendingBotMessage />}
    </Box>
  );
};
